<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100">
                  <contentList
                  @selectedCity="selectedCity"
                  @selectedProvince="selectedProvince"
                  @submitEditRepresentation="submitEditRepresentation"

                  :page="page"
                  :update-city-selected="updateCitySelected"
                  :city-selected     = "citySelected"
                  :province-selected = "provinceSelected"
                  :citys="citys"
                  :province-items="provinceItems"
                  :form-data-single-representation="formDataSingleRepresentation"
                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent :page="page" :table-data="tableData" @paganationChangePage="paganationChangePage" ></tableContent>
      </Loader>
  </div>
</template>

<script>
import contentList from '../components/editRepresentation/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/editRepresentation/tableContent';



export default {
  name: "editRepresentation",
  components: {
    contentList,
    appHeader,
    tableContent,
  },

  props: {

  },

  data() {
    return {
      loading                      : true,
      citys                        : [

      ],
      provinceItems                : [

      ],
      excelData                    : [
          {
            family         : 'محمد صالح معافی',
            city           : 'قم',
            representation : 'استان',
            phone          : '09198814783',
          },
        ],
      updateDataRepresentation     : {},
      formDataSingleRepresentation : {},
      citySelected                 : {
        id   : -1,
        name  : 'انتخاب کنید',
      },
      provinceSelected             : {
        id   : -1,
        name  : 'انتخاب کنید',
      },
      updateCitySelected           : 0,
      page                         : 0,
      checkEmptyCity          : 'default',
      searchAndGetDataTableAndchangePage    : {
        national_code : '',
        name          : '',
        city_id       : '',
        province_id   : '',
        description   : '',
        national_code : '',
        per_page      : 10,
        page          : 1,
      },
      tableData                   : [],
      page                        : 1,
      checkRunFirstGetDefaultProvinceAndCity  : 'initialLoaded',


    }
  },

  watch: {

  },

  created() {

  },

  mounted() {
    const singleRepresentation        = this.$route.query;
    delete singleRepresentation['password'];
    this.formDataSingleRepresentation = singleRepresentation;

    this.getRepresentationAndProvinceAndCity();
  },


  methods: {
    paganationChangePage(data){
      this.page                                    = data;
      this.loading                                 = true;
      this.searchAndGetDataTableAndchangePage.page = this.page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';

      // citySelected has nothing item select  //
      if (this.citySelected.id == -1) {
        this.searchAndGetDataTableAndchangePage.city_id = '';
      }

      this.getRepresentationAndProvinceAndCity();
    },

    updateRepresentation(data){
      this.loading = true;
      // citySelected has nothing item select  //
      if (this.citySelected.id == -1) {
        this.formDataSingleRepresentation.city_id = '';
      }


      this.$store
      .dispatch('listRepresentation/updateRepresentation', {
        data : {
          ...this.formDataSingleRepresentation,
        }
      })
      .then((res)=>{
        this.loading = false;

        if (res.is_successful) {
          this.$message.success(res.message);
          this.$router.push({name:'listRepresentation'})
        }
        else {
          let concatMessage = '';
          for (let key in res.message) {
            const contentError = res.message[key];
            concatMessage+=contentError + ',';
          }
          this.$message.error(concatMessage)
        }

      })
    },

    submitEditRepresentation(){
      this.updateRepresentation();
    },

    selectedCity(data){

      if (data.id != -1) {
        this.citySelected   = data
        this.formDataSingleRepresentation.city_id = data.id;
      }


    },

    selectedProvince(data){

      if (this.checkEmptyCity != 'firstCheckSelectedCity') {
        this.citySelected  = {name:'انتخاب کنید',id:-1};
      }

      if (data.id != -1) {
        this.provinceSelected = data;
        this.formDataSingleRepresentation.province_id =  data.id;
        this.updateCitySelected++;
        this.citys               = data.city;
        this.checkEmptyCity = 'eventUpdate';
      }


    },

    getDefaultProvinceAndCity(dataProvinceAndCity){
      let getProvince           = [];
      let getCity               = [];
      const cityIdDefault       =  this.formDataSingleRepresentation.city_id;
      const provinceIdDefault   =  this.formDataSingleRepresentation.province_id;

      dataProvinceAndCity.data.map((t)=>{
          getProvince = [...getProvince,t];

          if (provinceIdDefault == t.id ) {
            this.provinceSelected  = t;
          }

          t.city.map((contentCity)=>{
            if (cityIdDefault == contentCity.id ) {
              this.citySelected  = contentCity;
            }
            getCity               = [...getCity,contentCity];
          })
      })

      this.citys               = getCity;
      this.provinceItems       = getProvince;
      this.checkEmptyCity = 'firstCheckSelectedCity';
    },

    findProvinceAndCityTable(listRepresentation){
          listRepresentation.map((contentRepresentation)=>{
              this.provinceItems.map((t)=>{
                if (t.id == contentRepresentation.province_id) {
                    contentRepresentation.findProvinceOfAllProvinces = t;
                    t.city.map((contentCity)=>{
                        if (contentCity.id == contentRepresentation.city_id) {
                            contentRepresentation.findCityOfAllCitys = contentCity;
                        }
                    })
                }
              })
        })
    },

    getRepresentationAndProvinceAndCity(){
      this.$store
      .dispatch('listRepresentation/getRepresentationAndProvinceAndCity', {
        data : {
          ...this.searchAndGetDataTableAndchangePage,
        }
      })
      .then((res)=>{
        this.loading                               = false;
        this.valueRepresentationAndProvinceAndCity = res;

        this.convertTimeStampInToJalali(res.listRepresentation.data);
        if (this.checkRunFirstGetDefaultProvinceAndCity == 'initialLoaded') {
          this.getDefaultProvinceAndCity(res.getProvinceAndCity);
        }
        this.findProvinceAndCityTable(res.listRepresentation.data);
        this.tableData    = res.listRepresentation.data;
      })
    },

    convertTimeStampInToJalali(listRepresentation){
      listRepresentation.map((t,i)=>{
        const resultConvert    = this.$moment.unix(t.updated_at).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');
        t.dateConvertedJali    =  resultConvert[0];
        t.timeConvertedJali    =  resultConvert[1];
      })
    },







  }


}
</script>
